import { DATE_FORMATS } from "../../../constants/date/date.js";
import { InsuranceType } from "../../../type/Appointment.js";
import format from "date-fns/fp/format";
import isValid from "date-fns/isValid";
import parse from "date-fns/parse";
const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}/;
const BDAY_REGEX = /\d{2}\.\d{2}\.\d{2,4}/;
const LONG_BDAY_FORMAT = DATE_FORMATS.DAY_MONTH_YEAR;
const toISODate = format(DATE_FORMATS.ISO_SHORT);
const formatBirthday = (date) => {
  const valueTrimmed = date.trim();
  const asDate = new Date(date);
  if (!valueTrimmed)
    return valueTrimmed;
  if (isValid(asDate) && ISO_DATE_REGEX.test(valueTrimmed))
    return toISODate(asDate);
  if (!BDAY_REGEX.test(valueTrimmed))
    throw new Error("Wrong birthday format");
  return toISODate(parse(valueTrimmed, LONG_BDAY_FORMAT, /* @__PURE__ */ new Date()));
};
const ensureConditionalFieldValues = (values) => {
  const clone = { ...values };
  if (values.gender === "MALE")
    clone.isPregnant = false;
  if (!values.isPregnant)
    delete clone.pregnantMonths;
  if (!values.isSmoker)
    delete clone.cigarettesPerDay;
  if (values.type !== InsuranceType.PRIVATE_INSURANCE) {
    delete clone.insuranceCompanyId;
    delete clone.insuranceCompany;
  }
  if (values.type === InsuranceType.PRIVATE_INSURANCE) {
    delete clone.dentalInsuranceCompany;
    delete clone.dentalInsuranceCompanyId;
    clone.hasDentalInsurance = false;
  }
  if (!values.hasDentalInsurance) {
    delete clone.dentalInsuranceCompany;
    delete clone.dentalInsuranceCompanyId;
  }
  if (!values.hasFamilyInsurance) {
    delete clone.holderCity;
    delete clone.holderStreet;
    delete clone.holderZipcode;
    delete clone.holderFirstName;
    delete clone.holderLastName;
    delete clone.holderBirthday;
  }
  return clone;
};
const wishesForPage1 = [
  {
    key: "what_is_important",
    score: 0
  },
  {
    key: "afraid_of_dentist_treatment",
    flag: false
  }
];
const wishesForPage2 = [
  {
    key: "has_toothache",
    score: 0
  },
  {
    key: "satisfied_tooth_color",
    score: 0
  },
  {
    key: "satisfied_tooth_position",
    score: 0
  }
];
const wishesForPage3 = [
  {
    key: "bad_breath",
    flag: false
  },
  {
    key: "grind_teeth",
    flag: false
  },
  {
    key: "snor",
    flag: false
  },
  {
    key: "have_amalgam_filling_to_replace",
    flag: false
  }
];
const wishesForPage4 = [
  {
    key: "has_bridges",
    flag: void 0
  },
  {
    key: "informed_implants",
    flag: void 0,
    requireTrue: "has_bridges"
  }
];
var WishesFieldType = /* @__PURE__ */ ((WishesFieldType2) => {
  WishesFieldType2["RATING"] = "RATING";
  WishesFieldType2["TOGGLE"] = "TOGGLE";
  return WishesFieldType2;
})(WishesFieldType || {});
export {
  BDAY_REGEX,
  ISO_DATE_REGEX,
  LONG_BDAY_FORMAT,
  WishesFieldType,
  ensureConditionalFieldValues,
  formatBirthday,
  toISODate,
  wishesForPage1,
  wishesForPage2,
  wishesForPage3,
  wishesForPage4
};
